import { render, staticRenderFns } from "./device.vue?vue&type=template&id=3040c4b4&scoped=true&"
import script from "./device.vue?vue&type=script&lang=js&"
export * from "./device.vue?vue&type=script&lang=js&"
import style0 from "./device.vue?vue&type=style&index=0&id=3040c4b4&lang=less&scoped=true&"
import style1 from "./device.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3040c4b4",
  null
  
)

export default component.exports